import React from "react";
import "../styles/EChallan.css";

export default function EChallan() {
  return (
    <div className="page-container">
      <h1 className="page-title">Check E-Challan</h1>

      {/* 🔥 Coming Soon */}
      <h2 style={{ color: "#003566" }}>🚧 Coming Soon</h2>

      <p style={{ color: "#666" }}>
        This feature will be available soon. Stay tuned!
      </p>
    </div>
  );
}